import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Demands } from 'base/api';
import {
  BusinessForwardAdvisorySearchList,
  BusinessForwardQuotesSearchList,
  BusinessForwardChoosedList,
  BusinessForwardedList
} from 'components/business';
import _ from 'lodash';
import {Collapse} from 'react-collapse';
import {PropTypes} from 'prop-types';
import {toastr} from 'react-redux-toastr';
import { ShowIf } from 'components/utils';

class NeedOffersForwardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      choosedBusinessesList: [],
      choosedIdList: [],
      forwardBusinessesList: [],
      isOpened: false
    };

    this.handleChooseBusiness = this.handleChooseBusiness.bind(this);
    this.handleRemoveBusiness = this.handleRemoveBusiness.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleToggleCollapse = this.handleToggleCollapse.bind(this);
    this.loadForwardedBusinessList = this.loadForwardedBusinessList.bind(this);
    this.reload = this.reload.bind(this);
  }

  static propTypes = {
    idDemand: PropTypes.string.isRequired
  }

  componentDidMount() {
    this.loadForwardedBusinessList();
  }

  loadForwardedBusinessList() {
    Demands.actions.listForwardedBusinesses.request({
      id: this.props.idDemand
    }).then(res => {
      let forwardBusinessesList = [];
      if (res && res.data && res.data.results) {
        res.data.results.forEach(item => {
          forwardBusinessesList.push(item.business);
        });
      }
      this.setState({forwardBusinessesList});
    });
  }

  handleChooseBusiness = (business) => {
    if (!business || !business.id) {
      return;
    }

    if (_.indexOf(this.state.choosedIdList, business.id) === -1) {
      const choosedBusinessesList = [...this.state.choosedBusinessesList, business];
      const choosedIdList = [...this.state.choosedIdList, business.id];
      this.setState({choosedBusinessesList, choosedIdList});
    }
  }

  handleRemoveBusiness = (id) => {
    if (!id) {
      return;
    }

    let choosedBusinessesList = [...this.state.choosedBusinessesList];
    let choosedIdList = [...this.state.choosedIdList];
    if (_.indexOf(choosedIdList, id) !== -1) {
      choosedBusinessesList = _.filter(choosedBusinessesList, item => item.id !== id);
      choosedIdList = _.filter(choosedIdList, item => item !== id);
      this.setState({choosedBusinessesList, choosedIdList});
    }
  }

  handleToggleCollapse() {
    this.setState({isOpened: !this.state.isOpened});
  }

  reload() {
    this.setState({
      choosedBusinessesList: [],
      choosedIdList: []
    }, () => {
      this.loadForwardedBusinessList();
    });
  }

  handleSubmit() {
    return this.props.dispatch(Demands.actions.forwardBusinesses({id: this.props.idDemand}, {
      data: this.state.choosedIdList
    })).then(res => {
      this.reload();
      toastr.removeByType("success");
      let message = 'Yêu cầu báo giá đã được chuyển tiếp thành công';
      if (this.props.demand && this.props.demand.type === 'TUVAN') {
        message = 'Yêu cầu tư vấn đã được chuyển tiếp thành công';
      }
      toastr.success("Thành công", message);
    }).catch(err => {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
    });
  }

  render() {
    const { demand } = this.props;
    return (
      <div>
        <h1 className='user-header collapse-header' onClick={this.handleToggleCollapse}>Chuyển tiếp</h1>
        <Collapse isOpened={this.state.isOpened}>
          <div className="container-fluild">
            <div className="row">
              <div className="col-lg-12">
                <div className="content">
                  <h3>Các doanh nghiệp đã được chuyển tiếp</h3>
                  <BusinessForwardedList data={this.state.forwardBusinessesList}/>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
              <ShowIf condition={demand && demand.type === 'BAOGIA'}>
                <BusinessForwardQuotesSearchList
                  onChoose={this.handleChooseBusiness}
                  disabledIdList={this.state.choosedIdList}
                />
              </ShowIf>
              <ShowIf condition={demand && demand.type === 'TUVAN'}>
                <BusinessForwardAdvisorySearchList
                  onChoose={this.handleChooseBusiness}
                  disabledIdList={this.state.choosedIdList}
                />
              </ShowIf>
              </div>
              <div className="col-lg-6">
                <div className="content">
                  <h3>Các doanh nghiệp được chọn</h3>
                  <BusinessForwardChoosedList
                    onRemove={this.handleRemoveBusiness}
                    data={this.state.choosedBusinessesList}
                  />
                  <div className="text-center">
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={this.handleSubmit}
                      disabled={this.state.choosedIdList.length === 0}>
                      Chuyển tiếp
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    );
  }
}

export default connect()(NeedOffersForwardContainer);


// WEBPACK FOOTER //
// ./components/demands/NeedOffersForwardContainer.jsx